import { setContext, setTag, setUser } from '@sentry/vue';

import { StatusCode, env, isFetchError, useFeature } from '~~core';

import { TogglesParams, fetchToggles } from '../services/toggles';
import { Decisions, features } from '../utils';

let hasFetchedToggles = false;

export default defineNuxtRouteMiddleware(async (to) => {
  if (hasFetchedToggles || !('signatureRequestKey' in to.params)) return; // Skip, since this key is needed to fetch toggles

  const tryFetchToggles = async (params?: TogglesParams) => {
    const toggles = await fetchToggles(to.params.signatureRequestKey, params);

    for (const [key, value] of Object.entries(toggles)) {
      features.setFeature(key as Decisions, value);
    }

    setContext('Feature Flags', toggles);
    setUser({ id: to.params.signatureRequestKey });
    if (to?.query?.embedded === 'true') setTag('isEmbedded', true);

    if (env.TAVOLA_BASE_URL) {
      setContext('Admin', {
        querySigner: `${env.TAVOLA_BASE_URL}/admin/notarial_signers?q%5Bkey_eq%5D=${to.params.signatureRequestKey}&commit=Filtrar&order=id_desc`,
      });
    }

    window.toggles = toggles;

    hasFetchedToggles = true;
  };

  try {
    await tryFetchToggles();
  } catch (error) {
    if (!(isFetchError(error) && error?.response?.status === StatusCode.GONE)) throw error;

    if (useFeature(Decisions.STORY_NEW_UNAVAILABLE_PAGE).isEnabled.value) await tryFetchToggles({ bypassGone: true });
  }
});
